<!-- src/layouts/FrontLayout.vue -->
<!--App.vue-->
<template>
  <div id="app">
    <AppNavbar v-if="!$route.meta.hideNavFooter" />
    <router-view />
    <AppFooter v-if="!$route.meta.hideNavFooter" />
  </div>
</template>

<script>
import AppNavbar from '@/components/__Navbar.vue';
import AppFooter from '@/components/__Footer.vue';

export default {
  name: 'App',
  components: {
    AppNavbar,
    AppFooter
  }
}
</script>

<style>
html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
}

body.has-navbar {
  padding-top: 80px;
}

body.no-navbar {
  padding-top: 0;
}


#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

main,
.router-view {
  flex: 1;
  display: flex;
  flex-direction: column;
}

footer {
  text-align: center;
  padding: 20px 0;
  background-color: #f8f8f8;
  border-top: 1px solid #e0e0e0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  margin-top: auto;
}

.form-group input {
  font-size: 24px;
}

/* 讓 placeholder 也變大 */
.form-group input::placeholder {
  font-size: 24px;
  color: #aaa;
  /* 預設提示文字顏色 */
}

h1 {
  font-size: 2.0rem;
}

h2 {
  font-size: 1.8rem;
}

h3 {
  font-size: 1.5rem;
}

.step-indicator {
  font-size: 1.05rem;
}

label {
  font-size: 1.25rem;
}

input {
  font-size: 1.5rem;
}

button {
  font-size: 1.5rem;
}

.error-message {
  font-size: 1.5rem;
  color: red;
  margin-top: 5px;
}


@media (max-width: 768px) {
  .form-group input {
    font-size: 20px;
  }

  /* 讓 placeholder 也變大 */
  .form-group input::placeholder {
    font-size: 24px;
    color: #aaa;
    /* 預設提示文字顏色 */
  }
}

/* 文字 */
@media (max-width: 768px) {
  .register-card {
    flex-direction: column;
  }

  h1 {
    font-size: 2.0rem;
  }

  h2 {
    font-size: 1.8rem;
  }

  h3 {
    font-size: 1.5rem;
  }

  .step-indicator {
    font-size: 1.05rem;
  }

  label {
    font-size: 1.25rem;
  }

  input {
    font-size: 1.5rem;
  }

  button {
    font-size: 1.5rem;
  }

  .error-message {
    font-size: 1.25rem;
  }
}
</style>